module.exports = __webpack_public_path__ + "static/card3-b18992a90144459fdf6de9d6c5432b5c.png";